function destroyPetCarousels() {
  document.querySelectorAll(".carousel-pet.glide").forEach((el) => {
    if (!el._petCarouselGlide) return
    el._petCarouselGlide.destroy()
    delete el._petCarouselGlide
  })
}

function mountPetCarousels() {
  if (typeof Glide === "undefined") return

  document.querySelectorAll(".carousel-pet.glide").forEach((el) => {
    if (el._petCarouselGlide) {
      el._petCarouselGlide.destroy()
      delete el._petCarouselGlide
    }

    const slides = el.querySelectorAll(".glide__slide")
    if (!slides.length) return

    const perView = Math.min(4, slides.length)
    const glide = new Glide(el, {
      type: "slider",
      perView,
      gap: 20,
      rewind: false,
      breakpoints: {
        768: { perView: Math.min(2, slides.length) },
      },
    })

    const updateButtons = () => {
      const currentIndex = glide.index
      const totalSlides = el.querySelectorAll(".glide__slide").length
      const pv = glide.settings.perView
      const nextBtn = el.querySelector('[data-glide-dir=">"]')
      const prevBtn = el.querySelector('[data-glide-dir="<"]')

      if (nextBtn) nextBtn.disabled = currentIndex >= totalSlides - pv
      if (prevBtn) prevBtn.disabled = currentIndex === 0
    }

    glide.on("run.after", updateButtons)
    glide.mount()
    el._petCarouselGlide = glide
    updateButtons()
  })
}

document.addEventListener("turbo:load", mountPetCarousels)
document.addEventListener("turbo:before-cache", destroyPetCarousels)

// Primeira carga sem evento turbo:load em alguns cenários
if (document.readyState !== "loading") {
  mountPetCarousels()
} else {
  document.addEventListener("DOMContentLoaded", mountPetCarousels)
}
